window.app = window.app || {};

window.app.announcementBar = {
  el: document.querySelector('.mt-announcement-bar-section'),

  init: function () {
    const _this = this;
    _this.el && document.documentElement.style.setProperty('--announcement-bar-height', `${_this.el.clientHeight}px`);

    _this.slider = new Swiper(_this.el.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 0,
      height: 50,
      direction: 'horizontal',
      draggable: false,
      allowTouchMove: false,
      speed: 1500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    });
  },
};
window.app.announcementBar.init();